import React, { Component } from 'react';
import { connect } from 'react-redux';
import find from 'lodash/find';
import _ from 'lodash';

import { FLOAT_COLUMNS, ROUND_COLUMNS } from 'components/DiamondList/table-config';
import { handleAlter, LISTINGPAGES } from './DiamondList/DiamondListFunctions';
import MagnifierImage from './DiamondDetail/MagnifierImage';
import Heading from './common/Heading';
import NoDataShow from './common/NoDataShow';
import DiamondListingAction from './common/DiamondListing/DiamondListingAction';
import { getGridHeight } from './DiamondList';
import { formatNumber } from './common/DiamondListing/SelectStone';
import CheckBox from './common/CheckBox';
import { getBidType } from './NewArrivalBidIt';
import { DIAMOND_DATA_BY_ID } from '../constants/apiConstant';
import { LOCAL_STORAGE_VAR, FILE_URLS, DIAMOND_BID, KYC_STATUS } from '../constants/Common';
import UtilService from '../services/util';
import detailView from '../constants/DiamondDetail';
import DetailViewAuth from '../constants/DiamAuth';

const currentType = 'DiamondCompare';

class DiamondCompare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      checked: [],
      inTrackDiamonds: [],
    };
  }

  componentDidMount() {
    this.fetch();
  }

  componentDidUpdate(prevProps) {
    if (this.props.commonData.strip !== prevProps.commonData.strip) this.forceUpdate();
  }

  fetch = () => {
    const self = this;
    const ids = localStorage.getItem(`${LOCAL_STORAGE_VAR}-compare-diamond`)
      ? JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_VAR}-compare-diamond`))
      : [];
    if (ids.length === 0 || ids.length === 1) {
      this.setState({ data: [] });
      return;
    }
    const obj = DIAMOND_DATA_BY_ID;
    obj.request = {
      id: ids,
      isReturnTotal: true,
      isReturnIntrack: true,
    };
    this.setState({ loading: true });
    UtilService.callApi(obj, (err, data) => {
      let rows = [];
      let inTrackDiamonds = [];
      if (data && data.code === 'OK') {
        rows = data.data.list;
        inTrackDiamonds = data.data.inTrackDiamonds;
      }
      self.setState({ data: rows, inTrackDiamonds, loading: false });
    });
  };

  getMap = (name, key, extra = '') => {
    return (
      <tr>
        <td>{name}</td>
        {this.state.data.map((x) => {
          return (
            <td>
              {(!x[key]
                ? '-'
                : FLOAT_COLUMNS.includes(key)
                ? formatNumber(parseFloat(x[key]))
                : ROUND_COLUMNS.includes(key)
                ? formatNumber(Math.round(x[key]))
                : x[key]) + extra}
            </td>
          );
        })}
      </tr>
    );
  };

  removeCompare = (id) => {
    let ids = localStorage.getItem(`${LOCAL_STORAGE_VAR}-compare-diamond`)
      ? JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_VAR}-compare-diamond`))
      : [];
    ids = ids.filter((el) => el !== id);
    if (ids.length === 1) ids = [];
    localStorage.setItem(`${LOCAL_STORAGE_VAR}-compare-diamond`, JSON.stringify(ids));
    this.setState({
      data: this.state.data.length === 2 ? [] : this.state.data.filter((el) => el.id !== id),
      checked: this.state.data.length === 2 ? [] : this.state.checked.filter((el) => el.id !== id),
    });
  };

  render() {
    const { data } = this.state;
    const gridHeight = getGridHeight(
      [
        'diamondListingAction',
        'headerTopMenu',
        'selectStonHeader',
        'covidStrip',
        'HeaderStripBlock',
        'comparPageHead',
        'mobileSearchBottom',
      ],
      50,
    );

    const fsNow = localStorage.getItem(`${LOCAL_STORAGE_VAR}-now`)
      ? JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_VAR}-now`)).split('/')[1]
      : '';

    const userData = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-user`);

    const view = userData?.account?.isApproved === KYC_STATUS.APPROVED ? detailView : DetailViewAuth;
    const path = fsNow.split('?')?.[0];
    return (
      <>
        <div className="compareMainPage">
          <div className="d-flex justify-content-between align-items-center mb-10 comparPageHead">
            <Heading title={'Compare Stones (' + this.state.data.length + ')'} className="mb-0" />
          </div>
          {!this.state.loading && !this.state.data.length ? <NoDataShow /> : null}
          {!this.state.loading && this.state.data.length ? (
            <div className="compareTable" style={{ height: gridHeight, overflow: 'auto' }}>
              <table>
                <tr>
                  <td className="compareHead">Diamond Image</td>
                  {this.state.data.map((x, index) => {
                    return (
                      <td key={index} className="compareHead compareImage">
                        <MagnifierImage
                          tempSrc={require('../assets/svg/camera.svg')}
                          image={FILE_URLS.img.replace('***', x.mfgStnId)}
                          className="diamondCompareImg"
                        />
                        <div className="closeImage" onClick={() => this.removeCompare(x.id)}>
                          <img src={require('../assets/svg/Compare/close-red.svg')} alt="" />
                        </div>
                        <div className="checkImageBox">
                          <CheckBox
                            checked={find(this.state.checked, { stoneId: x.stoneId })}
                            onChange={() => {
                              const checked = handleAlter(this.state.checked, x, 'stoneId');
                              this.setState({ checked });
                            }}
                          />
                        </div>
                      </td>
                    );
                  })}
                </tr>
                {_.keys(view).map((k) =>
                  _.keys(_.groupBy(view[k]['data'], 'part')).map((k1) => {
                    const source = _.groupBy(view[k]['data'], 'part');
                    return source[k1].map((k2) => {
                      return (
                        <tr>
                          <td>{k2.label}</td>
                          {this.state.data.map((x) => {
                            return (
                              <td>
                                {(!x[k2.key]
                                  ? '-'
                                  : FLOAT_COLUMNS.includes(k2.key)
                                  ? formatNumber(parseFloat(x[k2.key]))
                                  : ROUND_COLUMNS.includes(k2.key)
                                  ? formatNumber(Math.round(x[k2.key]))
                                  : x[k2.key]) + ''}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    });
                  }),
                )}
                {/* {this.getMap('Stone No', 'vStnId')}
                                {this.getMap('Lab', 'lbNm')}
                                {this.getMap('Shape', 'shpNm')}
                                {this.getMap('Carat', 'crt')}
                                {this.getMap('Location', 'locNm')}
                                {this.getMap('Color', 'colNm')}
                                {this.getMap('Clarity', 'clrNm')}
                                {this.getMap('Shade', 'shdNm')}
                                {this.getMap('Rap ($)', 'rap')}
                                {this.getMap('Discount%', 'back')}
                                {this.getMap('Price/Carat ($)', 'ctPr')}
                                {this.getMap('Amount ($)', 'amt')}
                                {this.getMap('Certificate No', 'rptNo')}
                                {this.getMap('Fluorescence', 'fluNm')}
                                {this.getMap('Cut', 'cutNm')}
                                {this.getMap('Polish', 'polNm')}
                                {this.getMap('Symmetry', 'symNm')}
                                {this.getMap('Brown', 'shdNm')}
                                {this.getMap('Milky', 'mlkNm')}
                                {this.getMap('Mix Tinge', 'mixTintNm')}
                                {this.getMap('Depth %', 'depPer')}
                                {this.getMap('Table %', 'tblPer')}
                                {this.getMap('Length', 'length')}
                                {this.getMap('Width', 'width')}
                                {this.getMap('Depth', 'height')}
                                {this.getMap('Crown Angle', 'cAng')}
                                {this.getMap('Crown Height', 'cHgt')}
                                {this.getMap('Pav Angle', 'pAng')}
                                {this.getMap('Pav Height', 'pHgt')}
                                {this.getMap('Girdle', 'grdl')}
                                {this.getMap('Lab Comments', 'lbCmt')}
                                {this.getMap('Natural', 'natural')}
                                {this.getMap('Culet', 'cult')}
                                {this.getMap('H&A', 'hANm')} */}
                {/* {this.getMap('Eye Clean', 'eClnNm')} */}
              </table>
            </div>
          ) : null}
        </div>
        <DiamondListingAction
          {...this.state}
          {...this.props}
          checkedData={this.state.checked}
          nocompare
          nopaginate
          currentType={currentType}
          clearAll={() => this.setState({ checked: [] })}
          fetch={this.fetch}
          noconfirm
          nocart
          noquote
          nooffice={
            getBidType() === DIAMOND_BID.TYPE.BLIND || path === LISTINGPAGES.BID || fsNow === LISTINGPAGES.MYBID
          }
          nonote={fsNow === LISTINGPAGES.BID || fsNow === LISTINGPAGES.MYBID}
          nowatch={
            fsNow === LISTINGPAGES.CONFIRM ||
            fsNow === LISTINGPAGES.WATCHLIST ||
            path === LISTINGPAGES.BID ||
            fsNow === LISTINGPAGES.MYBID ||
            fsNow === LISTINGPAGES.UPCOMING
          }
        />
      </>
    );
  }
}

export default connect((props) => {
  return { commonData: props.commonData };
}, {})(DiamondCompare);
